<template>
  <SelectWithSearch
    label="Motivo:"
    placeholder="Selecione um tipo"
    v-model="input"
    :clearable="clearable"
    :change="change"
    :options="types"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">
        {{ `${props.data.id} - ${props.data.description}` }}
      </div>
    </template>
    <template slot="no-options"> Selecione um tipo </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">
        {{ `${props.data.id} - ${props.data.description}` }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';

export default {
  name: 'SelectNfseCancellationType',
  components: {
    SelectWithSearch,
  },
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      types: [
        {
          id: 1,
          description: 'Erro de emissão',
        },
        {
          id: 2,
          description: 'Serviço não prestado',
        },
        {
          id: 3,
          description: 'Duplicidade de nota',
        },
      ],
      input: null,
    };
  },
  methods: {
    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
